/* Does async.js have something like this? */
/* What is that library for? Is it useful in 2022? */
export const sleep = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
